import { Box, Users, List, Zap, Calendar, Shield } from "react-feather";
import { hasPermission } from "../../Shared/Utils/userUtils";

const admin_routes = [];
if (hasPermission("list_user")) {
  admin_routes.push({
    path: `${process.env.PUBLIC_URL}/app/users`,
    bookmark: true,
    icon: Users,
    type: "link",
    title: "Usuarios",
  });
}
if (hasPermission("list_role")) {
  admin_routes.push({
    title: "Roles",
    icon: Shield,
    type: "link",
    path: `${process.env.PUBLIC_URL}/app/roles`,
  });
}
if (hasPermission("list_entity")) {
  admin_routes.push({
    path: `${process.env.PUBLIC_URL}/app/entities`,
    icon: Box,
    type: "link",
    title: "Entidades",
  });
}
if (hasPermission("list_list")) {
  admin_routes.push({
    title: "Listas",
    icon: Calendar,
    type: "sub",
    path: `${process.env.PUBLIC_URL}/app/calendar/basic-calendar`,
    bookmark: true,
    active: false,
    children: [
      {
        path: `${process.env.PUBLIC_URL}/app/listings/jurisdictions`,
        type: "link",
        title: "Jurisdiccion",
      },
      {
        path: `${process.env.PUBLIC_URL}/app/listings/districts`,
        type: "link",
        title: "Distrito",
      },
      {
        path: `${process.env.PUBLIC_URL}/app/listings/contact-charges`,
        type: "link",
        title: "Cargos",
      },

      {
        path: `${process.env.PUBLIC_URL}/app/listings/politic-spaces`,
        type: "link",
        title: "Espacio politico",
      },
      {
        path: `${process.env.PUBLIC_URL}/app/listings/blocks`,
        type: "link",
        title: "Bloque",
      },
      {
        path: `${process.env.PUBLIC_URL}/app/listings/comissions`,
        type: "link",
        title: "Comisiones",
      },

      {
        path: `${process.env.PUBLIC_URL}/app/listings/areas`,
        type: "link",
        title: "Area",
      },
      {
        path: `${process.env.PUBLIC_URL}/app/listings/provinces`,
        type: "link",
        title: "Provincias",
      },
      {
        path: `${process.env.PUBLIC_URL}/app/listings/cities`,
        type: "link",
        title: "Ciudades",
      },
    ],
  });
}

const menu_routes = [];

if (hasPermission("list_contact")) {
  menu_routes.push({
    menutitle: "General",
    menucontent: "Dashboards,Widgets",
    Items: [
      {
        title: "Contactos",
        icon: List,
        type: "link",
        path: `${process.env.PUBLIC_URL}/app/contacts`,
        bookmark: true,
      },
    ],
  });
}

menu_routes.push({
  menutitle: "Admin",
  menucontent: "Dashboards,Widgets",
  Items: admin_routes,
});

if (hasPermission("list_activity")) {
  menu_routes.push({
    menutitle: "Reportes",
    menucontent: "Dashboards,Widgets",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/app/reports/activity`,
        bookmark: true,
        icon: Zap,
        type: "link",
        title: "Actividad de usuarios",
      },
    ],
  });
}

export const MENUITEMS = menu_routes;
